module.exports = __webpack_public_path__ + "media/images/emblems/Buchillon-coat_of_arms-163fabf40208e885d4d1e2835602039c.svg";